module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 019.69a4f32d.jpg";